import { isServerRendering } from '@farmasiet/frontendcore-reactcomponents';

import { StorageAccessor } from './StorageAccessor';

export class LocalStorageAccessor extends StorageAccessor {
    static storage = (() => {
        if (isServerRendering()) return false;

        const uid = new Date();
        try {
            localStorage.setItem('uid', uid.toDateString());
            const result = localStorage.getItem('uid') == uid.toDateString();
            localStorage.removeItem('uid');
            return result && localStorage;
        } catch (exception) {
            return false;
        }
    })();
}
